import React, { useEffect, useState } from "react";
import axios from "axios";
import { Link, useNavigate, useParams } from "react-router-dom";
import { Card, Col, Form, Row } from "react-bootstrap";
import Swal from "sweetalert2";
import { BASE_URL } from "../../services/Api";
import { authHeader } from "../../services/auth-header";

const ViewBrand = () => {
  const navigate = useNavigate();
  const { id } = useParams();
  const { pointindex } = useParams();
  const [brandname, setbrandname] = useState("");
  // const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    const fetchBrandData = async () => {
      try {
        const response = await axios.get(BASE_URL + "brand/findById/" + id, {
          headers: authHeader(),
        });
        console.log(response.data);
        setbrandname(response.data.brandname);
      } catch (error) {
        Swal.fire({
          icon: 'error',
          title: 'Error',
          text: 'Failed to fetch brand data. Please try again.',
        });
      }
    };

    fetchBrandData();
  }, [id]);

  // const validateForm = () => {
  //   if (!brandname) {
  //     Swal.fire({
  //       icon: 'warning',
  //       title: 'Incomplete Form',
  //       text: 'Please enter a brand name.',
  //     });
  //     return false;
  //   }
  //   return true;
  // };

  // const handleSubmit = async () => {
  //   if (!validateForm()) return;
  //   setIsLoading(true);

  //   const brandData = {
  //     brandname: brandname,
  //   };

  //   try {
  //     await axios.put(`${BASE_URL}brand/update/${id}`, brandData, {
  //       headers: authHeader(),
  //     });
  //     Swal.fire({
  //       icon: 'success',
  //       title: 'Success',
  //       text: 'Brand details updated successfully!',
  //     });
  //     navigate("/brands");
  //   } catch (error) {
  //     Swal.fire({
  //       icon: 'error',
  //       title: 'Error',
  //       text: error.response?.data?.message || 'An error occurred. Please try again.',
  //     });
  //   } finally {
  //     setIsLoading(false);
  //   }
  // };

  // const getItem = (id) => {

  //   Swal.fire({
  //     title: 'Are you sure?',
  //     text: "You won't be able to revert this!",
  //     icon: 'warning',
  //     showCancelButton: true,
  //     confirmButtonColor: '#3085d6',
  //     cancelButtonColor: '#d33',
  //     confirmButtonText: 'Yes, delete it!'
  //   }).then((result) => {
  //     if (result.isConfirmed) {

  //       axios.delete(BASE_URL+ "brand/delete/"+ id,{
  //           headers: authHeader(),
  //       }
  //       ).then(res => {
  //           console.log(res.data)
  //       navigate(`/brandindex/${pointindex}`)
  //       })
  //       .catch((error)=>{
  //         Swal.fire(error.response.data);
  //       })
  //       Swal.fire(
  //         'Deleted!',
  //         'Deleted successfully.',
  //         'success'
  //       )
  //     }
  //   })
  // };

  const getItem = (id) => {
    Swal.fire({
      title: 'Are you sure?',
      text: "You won't be able to revert this!",
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Yes, delete it!'
    }).then((result) => {
      if (result.isConfirmed) {
        axios.delete(BASE_URL + "brand/delete/" + id, {
          headers: authHeader(),
        })

          .then(response => {
            console.log('brand', response);
            if (response.data.length === 0) {
              Swal.fire(
                'Warning',
                'Brand present in another module. Delete operation has been cancelled.',
                'warning'
              );
            } else {
              console.log(response.data);
              navigate(`/brandindex/${pointindex}`);
              Swal.fire(
                'Deleted!',
                'Deleted successfully.',
                'success'
              );
            }
          })
          .catch((error) => {
            Swal.fire(
              'Error',
              error.response.data,
              'error'
            );
          });
      }
    });
  };


  return (

    <Card className="card">
      <Card.Header className="card-header">
        <h6>VIEW BRAND</h6>
        <div className="view-buttons">
          {/* <Link><button className="button-70" onClick={()=>getItem(id)}>DELETE</button></Link> */}
          {/* <Link  to={`/brandEdit/${id}/${pointindex}`}><button className="button-70">EDIT</button></Link> */}
          <Link to="/brandindex/1">
            <button className="button-70">BACK</button>
          </Link>
        </div>
      </Card.Header>
      <Card.Body>
        <Form>
          <Row>
            <Col md={6}>
              <Form.Group controlId="formbrandname">
                <Form.Label>Brand Name</Form.Label>
                <Form.Control
                  value={brandname}
                  onChange={(e) => setbrandname(e.target.value)}
                  placeholder="Enter brand name"
                  disabled
                />
              </Form.Group>
            </Col>
            {/* <button type="button" onClick={handleSubmit} disabled={isLoading}>
              {isLoading ? <Spinner animation="border" size="sm" /> : 'UPDATE'}
            </button> */}
          </Row>
        </Form>
      </Card.Body>
    </Card>
  );
};

export default ViewBrand;
